import React from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import FormControl from '@mui/material/FormControl'
import { SelectChangeEvent } from '@mui/material/Select'
import { IncidentPerimeter } from '../../utils/constants'
import { systemLabel } from '../../utils/systemLabel'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import '../../i18n'

interface SelectIncidentPerimeterProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child?: React.ReactNode) => void
}

const SelectIncidentPerimeter: React.FC<SelectIncidentPerimeterProps> = ({
  value,
  onChange,
}) => {
  const menu = useExclusiveMenu()
  const { t } = useTranslation()

  const selectOptions = IncidentPerimeter.map((Control) => ({
    value: Control,
    label: systemLabel(t, 'incidentPerimeter', Control),
  }))

  const selectedOption =
    selectOptions.find((opt) => opt.value === value) || null

  const handleSelectChange = (selected: any) => {
    const event = {
      target: { value: selected ? selected.value : '' },
    } as SelectChangeEvent<string>
    onChange(event)
  }

  return (
    <FormControl fullWidth style={{ width: '100%' }}>
      <Select
        value={selectedOption}
        onChange={handleSelectChange}
        options={selectOptions}
        placeholder={t('Perimeter')}
        styles={incyiaSelectStyles}
        {...menu}
      />
    </FormControl>
  )
}

export default SelectIncidentPerimeter
